import { render } from "./PlayChess.vue?vue&type=template&id=ff62f46c&scoped=true"
import script from "./PlayChess.vue?vue&type=script&lang=js"
export * from "./PlayChess.vue?vue&type=script&lang=js"

import "./PlayChess.vue?vue&type=style&index=0&id=ff62f46c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff62f46c"]])

export default __exports__